import React, { useState } from "react";
import { defaultStyles } from "../../../constants/style-constants/utils";
// import Modal from "./Modal";
import { Button } from "../../../components/styled-components/button";
import fileIcon from "../../../assets/images/DeathModuleNew/Icons.png";

import * as Style from "../styles/ModalStyle";
import { Icon, Modal, Select, Row, Col, Radio, Input } from "antd";
import moment from "moment";

const { Option } = Select;

function ViewModal({ show, close, fields, modalTitle, obj }) {
  const { styles } = defaultStyles;
  const [formData, setFormData] = useState();
  const [textField, setTextField] = useState(false);
  const [selectListCustomtext, setselectListCustomtext] = useState({});
  const handleSubmit = () => {
    close();
  };
  console.log("obj....", obj);

  for (let i = 0; i < fields.length; i++) {
    console.log("fieldssssss", fields[i]);
  }


  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, '');
    if (numericPhoneNumber.startsWith('1') && numericPhoneNumber.length === 11) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(4, 7)}-${numericPhoneNumber.slice(7)}`;
    } else if (numericPhoneNumber.startsWith('44') && numericPhoneNumber.length === 12) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(4, 8)} ${numericPhoneNumber.slice(8)}`;
    } else if (numericPhoneNumber.startsWith('49') && numericPhoneNumber.length === 12) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(4, 12)}`;
    } else if (numericPhoneNumber.startsWith('92') && numericPhoneNumber.length === 12) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(5, 12)}`;
    } else {
      return phoneWithCountryCode;
    }
  }

  return (
    <Modal footer={null} closable={false} visible={show} centered>
      {console.log("show in modal", show)}
      <Style.HeaderConatiner>
        <Style.ModalTitle> {modalTitle}</Style.ModalTitle>
        {/* <Icon type="close" onClick={close}></Icon> */}
      </Style.HeaderConatiner>

      <div
        style={{
          marginTop: "1rem",
          maxHeight: "25rem",
          overflow: "scroll",
          padding: "1rem",
        }}
      >
        {fields.map((item, idx) => {
          const {
            title,
            type,
            options = [],
            index = null,
            isRequired = false,
            def = null,
            isDisabled = false,
          } = item;
          switch (type) {
            case "email":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );
            case "input":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );
            case "emails":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );
              case "phoneNumber1":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && formatPhoneNumber(obj[index]) : ""}</Style.FieldValue>
                </div>
              );
            case "phoneNumber":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && formatPhoneNumber(obj[index]) : ""}</Style.FieldValue>
                </div>
              );
            case "phoneNumberA":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && formatPhoneNumber(obj[index]) : ""}</Style.FieldValue>
                </div>
              );
            case "multiple":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );

            case "select":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );
            case "select":
              return (
                <div key={idx}>
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );

            case "date":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && moment(obj[index]).format("DD-MM-YYYY") : ""}</Style.FieldValue>
                </div>
              );

            case "textarea":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                </div>
              );
              case "currency":
                return (
                  <div
                    key={idx}
                    style={{
                      marginTop: "8px",
                      borderBottom: "1px solid #e8e8e8",
                    }}
                  >
                    <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                    <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                  </div>
                );

            case "richtext1":
              return (
                <div
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && obj[index].replace(/<\/?[^>]+(>|$)/g, "") : ""}</Style.FieldValue>
                </div>
              );
              case "richtext2":
              return (
                <div
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && obj[index].replace(/<\/?[^>]+(>|$)/g, "") : ""}</Style.FieldValue>
                </div>
              );
            case "richtext":
              return (
                <div
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>{obj ? obj[index] && obj[index].replace(/<\/?[^>]+(>|$)/g, "") : ""}</Style.FieldValue>
                </div>
              );

            case "radio":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>
                    {" "}
                    {(obj && ((obj[index] === true && "Yes" || obj[index] === false && "No")) || (obj &&  obj[index] === "Yes" ? "Yes" :"No"))}
                  </Style.FieldValue>
                </div>
              );
              case "radio1":
              return (
                <div
                  key={idx}
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                  <Style.FieldValue>
                    {" "}
                    {obj ? obj[index] : ""}
                  </Style.FieldValue>
                </div>
              );

            case "document":
              return (
                <div
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <div className="custom-upload-style">
                    <Style.FieldTitle>{item.title} </Style.FieldTitle>{" "}
                    <Style.FieldValue>{obj ? obj[index] : ""}</Style.FieldValue>
                  </div>
                </div>
              );
            case "file":
              return (
                <div
                  style={{
                    marginTop: "1rem",
                    borderBottom: "1px solid #e8e8e8",
                  }}
                >
                  <Style.FieldTitle>{"Uploaded File"} </Style.FieldTitle>{" "}
                  <Style.FieldValue>
                    <a style={{ color: "#7d8fb3" }} href={obj && obj[index]} target="blank">
                      {" "}
                      {(obj && obj[index] && "File Exists") ||
                        "No file Uploaded"}{" "}
                    </a>
                  </Style.FieldValue>
                </div>
              );
              case "Image":
                return (
                  <div
                    style={{
                      marginTop: "1rem",
                      borderBottom: "1px solid #e8e8e8",
                    }}
                  >
                    <Style.FieldTitle>{"Uploaded File"} </Style.FieldTitle>{" "}
                    <Style.FieldValue>
                      <a style={{ color: "#7d8fb3" }} href={obj && obj[index]} target="blank">
                        {" "}
                        {(obj && obj[index]) &&
                        <img src={obj && obj[index]} width={50} height={50} style={{marginRight:"1rem"}} alt="image" />
                        }
                        {(obj && obj[index] && "File Exists") ||
                          "No file Uploaded"}{" "}
                      </a>
                    </Style.FieldValue>
                  </div>
                );
              case "audio":
                return (
                  <div
                    style={{
                      marginTop: "1rem",
                      borderBottom: "1px solid #e8e8e8",
                    }}
                  >
                    <Style.FieldTitle>{"Audio File"} </Style.FieldTitle>{" "}
                    <Style.FieldValue>
                      <a style={{ color: "#7d8fb3" }} href={obj && obj[index]} target="blank">
                        {" "}
                        {(obj && obj[index] && "File Exists") ||
                          "No file Uploaded"}{" "}
                      </a>
                    </Style.FieldValue>
                  </div>
                );
                case "video":
                  return (
                    <div
                      style={{
                        marginTop: "1rem",
                        borderBottom: "1px solid #e8e8e8",
                      }}
                    >
                      <Style.FieldTitle>{"Video File"} </Style.FieldTitle>{" "}
                      <Style.FieldValue>
                        <a style={{ color: "#7d8fb3" }} href={obj && obj[index]} target="blank">
                          {" "}
                          {(obj && obj[index] && "File Exists") ||
                            "No file Uploaded"}{" "}
                        </a>
                      </Style.FieldValue>
                    </div>
                  );
          }
        })}
      </div>

      <Style.WrapperButtons style={{ justifyContent: "center" }}>
        <Style.SaveButton onClick={close}>Cancel</Style.SaveButton>
      </Style.WrapperButtons>
    </Modal>
  );
}

export default ViewModal;
